
export const getStyles = () => ({
  link: {
    paddingLeft: 10,
  },
});
